import React, { useState, useEffect, useRef } from 'react'
import { Alert } from 'foundations-library/components'

interface Props {
    errorMessage: null | string | JSX.Element;
    className?: string;
}

/**
 * UI for displaying any number picker related error.
 */
const ErrorMessage = (props: Props): null | JSX.Element => {
    const [closeAlert, setCloseAlert] = useState(false)
    const alertRef = useRef<HTMLDivElement>(null)
    const handleCloseAlert = () => {
        setCloseAlert(true)
    }

    useEffect(() => {
        const shouldCloseAlert = !props.errorMessage
        setCloseAlert(shouldCloseAlert)
        if (!shouldCloseAlert) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    alertRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                })
            })
        }
    }, [props.errorMessage])

    if (!props.errorMessage || closeAlert) return null

    return (
        <div ref={alertRef} className={props.className}>
            <Alert level="error" icon={true}
                autocloseAfter={3000} onClose={handleCloseAlert}
            >
                {props.errorMessage}
            </Alert>
        </div>
    )
}

export default ErrorMessage
